import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("tb_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("tb_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("tb_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    // Nuovo flow: registrazione richiede verifica email prima del login
    if (r.data.verification_required) {
      return { verification_required: true, email: r.data.email };
    }
    localStorage.setItem("tb_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const verifyEmail = async (email, code) => {
    const r = await api.post("/auth/verify-email", { email, code });
    localStorage.setItem("tb_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const resendCode = async (email) => {
    return (await api.post("/auth/resend-code", { email })).data;
  };
  const forgotPassword = async (email) => {
    return (await api.post("/auth/forgot-password", { email })).data;
  };
  const resetPassword = async (email, code, new_password) => {
    const r = await api.post("/auth/reset-password", { email, code, new_password });
    localStorage.setItem("tb_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => {
    localStorage.removeItem("tb_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, verifyEmail, resendCode, forgotPassword, resetPassword, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() { return useContext(AuthCtx); }
